import { render, staticRenderFns } from "./EmployeesEnquirySalariesPaidCancel.vue?vue&type=template&id=49610a4c&scoped=true&"
import script from "./EmployeesEnquirySalariesPaidCancel.vue?vue&type=script&lang=js&"
export * from "./EmployeesEnquirySalariesPaidCancel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49610a4c",
  null
  
)

export default component.exports